import Step12 from '@/Classes/FollowUp/FollowUpPatint';
import Vue from 'vue';
export default {
  data() {
    return {
      selectedDrugGroup: null,
      patientTechnicianDrug: new Step12.Step12(null, '', null, null, null),
      selectedDrug: {},
      showActionDate: false,
      tempActionDate: '',
      allUsesDrugs: [],
      patientTechnicianDrugCooperationTypesList: [
        { label: 'نوع دارو و اقلام مصرفی استفاده شده', value: 1 },
        { label: 'بیمار نیاز به هیچ دارو/ اقلام مصرفی ندارد', value: 2 },
        { label: 'عدم همکاری بیمار از مصرف داروی تجویز شده', value: 3 },
      ],
      patientTechnicianDrugCooperationTypeValue: 1,
    };
  },
  methods: {
    drugGroupChange: function () {
      this.getListOfDrugsForOtherWithGroupId(this.selectedDrugGroup);
    },
    clearDateTime: function (type) {
      if (type == 'actionDate') {
        this.showActionDate = false;
        this.patientTechnicianDrug.actionDate = '';
        this.tempActionDate = '';
      }
    },
    dateTimeChange: function (type) {
      if (type == 'actionDate') {
        if (this.patientTechnicianDrug.actionDate) {
          this.tempActionDate = Vue.moment(this.patientTechnicianDrug.actionDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      }
    },
    addDrugUsage: function () {
      if (this.selectedDrug) {
        if (this.selectedDrug.id) {
          if (!this.patientTechnicianDrug.drugOrderTypeId) {
            this.showErrorAlert('نحوه ی تجویز نمی تواند خالی باشد');
            return;
          }
          if (!this.patientTechnicianDrug.dosage) {
            this.showErrorAlert('دوز نمی تواند خالی باشد');
            return;
          }
          if (!this.patientTechnicianDrug.actionDate) {
            this.showErrorAlert('زمان نمی تواند خالی باشد');
            return;
          }
        }
      }
      this.patientTechnicianDrug.drugId = Number(this.selectedDrug.id);
      this.patientTechnicianDrug.patientId = Number(this.patientId);
      this.addPatientTechnicianDrugFunction(this.patientTechnicianDrug);
    },
    setData: function (data) {
      this.selectedDrugGroup = null;
      this.patientTechnicianDrug = new Step12.Step12(null, '', null, null, null);
      this.selectedDrug = {};
      this.showActionDate = false;
      this.tempActionDate = '';
      this.allUsesDrugs = [];
      for (let i = 0; i < data.length; i++) {
        let time = '';
        if (data[i].actionDate) {
          time = Vue.moment(data[i].actionDate).format('HH:mm:ss');
        }
        this.allUsesDrugs.push({
          id: data[i].id,
          dosage: data[i].dosage,
          drug: data[i].drug.title,
          orderType: data[i].drugOrderType.title,
          time: time,
          group: ' ( ' + data[i].drug.drugGroup.title + ' ) ',
        });
      }
    },
    goToNextStep: function () {
      this.$root.$refs.FollowUpPatient.changeTab4Step(2, true);
    },
    backToStep11: function () {
      this.$root.$refs.FollowUpPatient.changeTab(3);
      this.$root.$refs.FollowUpPatient.changeTab3Step(3, true);
    },
  },
};
